module.exports = __webpack_public_path__ + "static/parade-2019-house12-8fde423fcb3063fd7975319c3aff5017.jpg";